import Vimeo from "@vimeo/player";

export default function VimeoPlayer() {
	const videos = document.querySelectorAll(".vimeo-player-global-block");
	const videoPlayBtns = document.querySelectorAll(
		".vimeo-player-global-block--play"
	);

	const options = {
		byline: false,
		portrait: false,
		title: false,
	};

	videos.forEach((video, index) => {
		let player = new Vimeo(video, options);

		videoPlayBtns[index].addEventListener("click", function () {
			player.play();
			videoPlayBtns[index].classList.add(
				"vimeo-player-global-block--play-hide"
			);
		});

		player.on("play", function () {
			console.log("played the video!");
			videoPlayBtns[index].classList.add(
				"vimeo-player-global-block--play-hide"
			);
		});

		player.getVideoTitle().then(function (title) {
			console.log("title:", title);
		});
	});
}
